import { Space } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import getMenuItemVisibility from "../navigation/getMenuItemsVisibility";
import UnbatchedDocsCollapse from "./batching/UnbatchedDocsCollapse";
import InventoryAlertCollapse from "./inventory/InventoryAlertCollapse";
import useUserPreferences from "../../hooks/useUserPreferences";

const Dashboard = () => {
  const { preferences } = useUserPreferences([
    "DisplayLowInventoryAlertHomePage",
  ]);

  const actorDetails = useSelector((state) => state.actor.details.data);
  const menuVisibility = getMenuItemVisibility(actorDetails);

  const showInventoryAlert =
    menuVisibility.SalesVolumeAndThresholds &&
    preferences?.DisplayLowInventoryAlertHomePage === true;

  return (
    <div style={{marginBottom: 16}}>
      <Space direction="vertical" size={16} style={{width: "100%"}}>
        {menuVisibility.AddBatch && <UnbatchedDocsCollapse/>}
        {showInventoryAlert && <InventoryAlertCollapse/>}
      </Space>
    </div>
  );
};

export default Dashboard;
